module.exports = __webpack_public_path__ + "static/nginr-website-mainPage-1-442147a1194c31066f320eb5a4b9b6bd.png";